import { Navigate } from "react-router-dom";
import { COMMISSION_HOME_PATH } from "./_utils";

export default function CommissionIndex() {
  return <Navigate to={COMMISSION_HOME_PATH} replace />;
}
